const EsitoControlloSiatel = {
    //
    // Summary:
    //     Il codice fiscale è corretto
    Corretto: 0,
    //
    // Summary:
    //     Il codice fiscale è stato sostituito da un'altro
    Sostituito: 1,
    //
    // Summary:
    //     Non Presente in base anagrafica
    NonValidato: 2,
    //
    // Summary:
    //     base di un omocodice
    BaseOmocodice: 3,
    //
    // Summary:
    //     Non è una persona fisica
    NonPersonaFisica: 5,
    //
    // Summary:
    //     Non utilizzabile
    Nonutilizzabile: 6,
    //
    // Summary:
    //     Più soggetti per la stessa anagrafica
    PiuSoggetti: 7,
    //
    // Summary:
    //     Indicata una partita iva al posto di un codice fiscale
    PartitaIVAIndicata: 8,
    //
    // Summary:
    //     Codice fiscale formalmente errato
    FormalmenteErrato: 9,
    //
    // Summary:
    //     USATO UN CODICE FISCALE AL POSTO DI PARTITA IVA
    IndicatoCodiceFiscale: 10,
    //
    // Summary:
    //     pROBLEMI NELL'ESECUZIONE DELLA PROCEDURA
    NonEffettuabile: 21,
    //
    // Summary:
    //     dATI INSUFFICIENTI O ERRATI PER L'INDIVIDUAZIONE DEL SOGGETTO
    DatiInsufficienti: 110,
    //
    // Summary:
    //     Soggetto non presente in archivio anagrafiche
    NonPresente: 111,
    //
    // Summary:
    //     Non presente in archivio persone giuridiche
    NonPresente2: 112,
    //
    // Summary:
    //     Il codice fiscale è formalmente errato
    CodiceFiscaleErrato: 2002,
    //
    // Summary:
    //     Mancano dati anagrafici nel tracciato
    DatiAnagraficiMancanti: 2010,
    //
    // Summary:
    //     Data di nascita incongruente
    DataNascitaErrata: 2011,
    //
    // Summary:
    //     Tipo record errato
    ErratoTipoRecord: 4000,
    //
    // Summary:
    //     Dati del codice fiscale assenti
    CodiceFiscaleAssente: 5100,
    //
    // Summary:
    //     Il codice fiscale deve essere ancora controllato
    DaControllare: 10000,
    //
    // Summary:
    //     Il controllo del codice fiscale è in corso ma non è stata ricevuta risposta dall'
    //     agenzia delle entrate
    ControlloInCorso: 10001,
};

export default EsitoControlloSiatel;
